import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-3 font-weight-bold text-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    persistent: "",
    "max-width": "450px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title || 'Confirm Action'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.message || 'Are you sure you want to proceed?'), 1),
              (_ctx.itemName && _ctx.itemType)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                    _createTextVNode(" You are about to delete the " + _toDisplayString(_ctx.itemType) + " named: ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.itemName), 1),
                    _cache[3] || (_cache[3] = _createTextVNode(". "))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.warningMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.warningMessage), 1))
                : _createCommentVNode("", true),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-2" }, "This action cannot be undone.", -1))
            ]),
            _: 1,
            __: [4]
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "grey darken-1",
                variant: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1,
                __: [5]
              }),
              _createVNode(_component_v_btn, {
                color: "error darken-1",
                variant: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm'))),
                loading: _ctx.loading
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Confirm")
                ])),
                _: 1,
                __: [6]
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}